var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.$t("activity_analyzer")}},[_c('div',{staticClass:"ActivityReport"},_vm._l((_vm.graphs),function(graph){return _c('iframe',{style:({ height: graph.height }),attrs:{"src":graph.url}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }